import { isOpen, today } from '../../util';
import { useAppState } from '../../contexts/AppStateContext';
import { useRetailerData } from '../../hooks/dutchie-queries';

const OpenOrClosed = () => {
    const { retailerId } = useAppState(); // Changed from useConfig
    const { data: retailerData, isFetched: isFetchedRetailerData } =
        useRetailerData(retailerId);

    // Add safety check for retailerData
    if (!isFetchedRetailerData || !retailerData) {
        return null;
    }
    const { curbsidePickup, delivery, driveThruPickup, pickup } =
        retailerData.fulfillmentOptions || {};
        
    return (
        <div className='headless-openorclosed-wrapper'>
            {retailerData.hours?.delivery?.[today()] &&
            retailerData.hours?.pickup ? (
                <>
                    {(curbsidePickup || driveThruPickup || pickup) ? (
                        <div className='headless-oc-option'>
                            {retailerData.hours.pickup[today()] && 
                             isOpen(retailerData.hours.pickup[today()]) ? (
                                <span className='headless-oc-open'>OPEN</span>
                            ) : (
                                <span className='headless-oc-closed'>
                                    CLOSED
                                </span>
                            )}
                            <span className='headless-oc-name'>Pickup</span>
                        </div>
                    ) : null}
                </>
            ) : null}

            {retailerData.hours?.delivery ? (
                <>
                    {delivery ? (
                        <div className='headless-oc-option'>
                            {retailerData.hours.delivery[today()] &&
                            isOpen(retailerData.hours.delivery[today()]) ? (
                                <span className='headless-oc-open'>OPEN</span>
                            ) : (
                                <span className='headless-oc-closed'>
                                    CLOSED
                                </span>
                            )}
                            <span className='headless-oc-name'>Delivery</span>
                        </div>
                    ) : null}
                </>
            ) : null}
        </div>
    );
};

export default OpenOrClosed;
